/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
/* eslint-disable object-shorthand */
/* eslint-disable no-shadow */
/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
// import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import React, { useCallback, useState, useEffect, useContext } from "react";
import { useDropzone } from "react-dropzone";
import { Formik } from "formik";
import { format } from "date-fns";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import * as Sentry from "@sentry/react";
import TextField from "@mui/material/TextField";
import { useSelector } from "react-redux";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Button from "../../../components/common/Button";
import Typography from "../../../components/common/new/Typography/Typography";
import { CommonStyles } from "../../../components/common/Button/commonButtonStyle";
import style from "./CreateTicketModal.style";
import Loader from "../../../components/common/Loader/Loader";
import Dropdown from "../../../components/common/new/Dropdown/Dropdown";
// import AutoCompleteDropdown from "../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import InputField from "../../../components/common/new/InputField/InputField";
// import DatePicker from "../DatePicker/DatePicker";
import TicketingSystem from "../../../services/api/ticketingSystem";
// import Member from "../../../services/api/member";
// import { debounce } from "../../../utils/helper";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import { AlertStatus } from "../../../contants";
import Modal from "../../../components/common/Modal/Modal";
import RemarksList from "../RemarksList/RemarksList";
import { selectUserRole } from "../../../redux/selectors/user";

const PROJECT_OPTIONS = [
  {
    key: "Bds",
    value: "BDS",
  },
  {
    key: "Contribution",
    value: "CONTRIBUTION",
  },
];

const PRIORITY_OPTIONS = [
  {
    key: (
      <Box display="flex" alignItems="center">
        <KeyboardDoubleArrowUpIcon style={{ color: "red" }} /> Highest
      </Box>
    ),
    value: "HIGHEST",
  },
  {
    key: (
      <Box display="flex" alignItems="center">
        <KeyboardArrowUpIcon style={{ color: "red" }} /> High
      </Box>
    ),
    value: "HIGH",
  },
  {
    key: (
      <Box display="flex" alignItems="center">
        <DragHandleIcon style={{ color: "rgb(250 215 24)" }} /> Medium
      </Box>
    ),
    value: "MEDIUM",
  },
  {
    key: (
      <Box display="flex" alignItems="center">
        <KeyboardArrowDownIcon style={{ color: "#0052cc" }} /> Low
      </Box>
    ),
    value: "LOW",
  },
  {
    key: (
      <Box display="flex" alignItems="center">
        <KeyboardDoubleArrowDownIcon style={{ color: "#0052cc" }} /> Lowest
      </Box>
    ),
    value: "LOWEST",
  },
];

const STATUS_OPTIONS = [
  {
    key: "Todo",
    value: "TO_DO",
  },
  {
    key: "In Progress",
    value: "IN_PROGRESS",
  },
  {
    key: "Done",
    value: "DONE",
  },
  {
    key: "Cancelled",
    value: "CANCELLED",
  },
];

// const MAX_RESULT = 5;

// const getMemberOptions = (members) =>
//   members.length
//     ? members.map((member) => ({
//         displayName: `${member.fullName} - ${member.memberId}`,
//         value: member.memberId,
//       }))
//     : [];

function CreateTicketModal({ open, onClose, mode, ticketId, onRefresh }) {
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedModule, setSelectedModule] = useState("");
  const [selectedPriority, setSelectedPriority] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedAssignee, setSelectedAssignee] = useState("");
  // const [selectedReporter, setSelectedReporter] = useState("");
  const [description, setDescription] = useState("");
  const [subject, setSubject] = useState("");
  const [loading, setLoading] = useState(false);
  // const [selectedAppointmentDate, setSelectedAppointmentDate] = useState(
  //   new Date()
  // );

  const toast = useContext(ToastAlertContext);
  const isViewMode = mode === "view";
  const [remarks, setRemarks] = useState([]);
  const [supportTicketId, setTicketId] = useState("");
  const [remark, setRemark] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [selectedPreAssignee, setSelectedPreAssignee] = useState("");
  const [bdsDate, setBDSDate] = useState("");
  const userRole = useSelector(selectUserRole);

  const fetchRemakrs = async () => {
    try {
      const result = await TicketingSystem.getRemarksData({
        id: ticketId,
      });
      setRemarks(result.data);
    } catch (err) {
      toast.show(err.message, AlertStatus.ERROR);
      Sentry.captureException(err);
    }
  };

  // const fetchTicketId = async () => {
  //   try {
  //     const result = await TicketingSystem.getRemarksData({
  //       id: ticketId,
  //     });
  //     setTicketId(result.data[0]);
  //   } catch (err) {
  //     toast.show(err.message, AlertStatus.ERROR);
  //     Sentry.captureException(err);
  //   }
  // };

  const [files, setFiles] = useState([]);
  const [attchFiles, setAttachFiles] = useState([]);

  const [moduleNameOptions, setModuleNameOptions] = useState([]);

  const getModuleNames = async () => {
    const response = await TicketingSystem.getModuleName();
    setModuleNameOptions(response.data);
  };

  useEffect(() => {
    if (open) {
      getModuleNames();
    }
  }, [open]);

  const formatKey = (key) => {
    return key
      .split("_")
      .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
      .join(" ");
  };

  const MODULE_OPTIONS = moduleNameOptions.map((option) => ({
    key: formatKey(option),
    value: option.toUpperCase(),
  }));

  const [assigneeNameOptions, setAssigneeNameOptions] = useState([]);

  const getAssigneeNames = async () => {
    const response = await TicketingSystem.getTicketAssignee();
    setAssigneeNameOptions(response.data);
  };

  useEffect(() => {
    if (open) {
      getAssigneeNames();
    }
  }, [open]);

  const ASSIGNEE_OPTIONS = assigneeNameOptions.map((option) => ({
    key: option.fullName,
    value: option.memberId,
  }));

  const resetForm = () => {
    setSelectedProject("");
    setSelectedModule("");
    setSelectedPriority("");
    setSelectedAssignee("");
    setSelectedStatus("");
    // setSelectedReporter("");
    setDescription("");
    setSubject("");
    // setOptions([]);
    setFiles([]);
    setRemark("");
    // setSelectedAppointmentDate(new Date());
  };

  const onView = async () => {
    try {
      setLoading(true);
      const id = ticketId;
      const result = await TicketingSystem.getTicketById(id);
      setSearchData(result.data);
      setSubject(result?.data?.subject);
      setSelectedProject(result?.data?.projectType);
      setSelectedModule(result?.data?.moduleName);
      setSelectedPriority(result?.data?.priority);
      // setSelectedReporter(result?.data?.reporterName);
      setSelectedPreAssignee(result?.data?.assigneeName);
      setDescription(result?.data?.description);
      setFiles(result?.data?.attachments);
      setSelectedStatus(result?.data?.status);
      setBDSDate(moment(result?.data?.createdAt).format("YYYY_MM_DD"));
      setTicketId(result?.data?.ticketId);
      const attachmentIds = result?.data?.attachments.map(
        (attachment) => attachment?.id
      );
      setAttachFiles(attachmentIds);
      const dueDateString = searchData.dueDate;

      if (dueDateString) {
        const dueDate = new Date(dueDateString);
        // setSelectedAppointmentDate(dueDate);
      }
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
      setLoading(false);
    }
  };

  const handleAttachments = async (file) => {
    const allowedFileTypes = [
      "application/msword",
      "application/vnd.ms-excel",
      "application/pdf",
      "text/plain",
      "text/csv",
      "application/xml",
      "text/xml",
      "image/png",
      "image/webp",
      "image/jpeg",
      "application/zip",
      "application/gzip",
      "application/x-zip-compressed",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/x-7z-compressed",
      "application/vnd.google-apps.document",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.google-apps.kix",
      "application/vnd.google-apps.form",
      "application/vnd.google-apps.presentation",
      "application/vnd.google-apps.spreadsheet",
    ];

    if (file) {
      if (!allowedFileTypes.includes(file.type)) {
        toast.show("Selected file format is not supported", AlertStatus.ERROR);
        return;
      }

      try {
        const formData = new FormData();
        formData.append("file", file);
        const response = await TicketingSystem.uploadAttachments({
          data: formData,
        });
        if (response.code === 200) {
          const { data } = response;
          setFiles((prevAttachmentsData) => [...prevAttachmentsData, data]);
          toast.show("File Attached Successfully", AlertStatus.SUCCESS);
        }
      } catch (error) {
        toast.show(
          "Error uploading file. Please try again.",
          AlertStatus.ERROR
        );
      }
    } else {
      toast.show("No file selected.", AlertStatus.ERROR);
    }
  };

  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      handleAttachments(file);
    });
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: true,
  });

  const handleRemoveAttachment = (attachmentIndex, attachmentId) => {
    setFiles((prevAttachments) =>
      prevAttachments.filter((_, index) => index !== attachmentIndex)
    );
    setFiles((prevAttachments) =>
      prevAttachments.filter((ide) => ide !== attachmentId)
    );
  };

  // const onDateSelect = (appointedAt) => {
  //   setSelectedAppointmentDate(new Date(appointedAt));
  // };

  const onFormSubmit = async () => {
    try {
      setLoading(true);
      const fileIds = files.map((file) => file.id);
      const id = ticketId;
      const payload = {
        remark: {
          data: {
            message: remark,
            event: "ticket update",
          },
        },
        projectType: selectedProject,
        moduleName: selectedModule,
        subject: subject,
        priority: selectedPriority,
        description: description,
        assigneeId: selectedAssignee,
        // dueDate: format(selectedAppointmentDate, "yyyy-MM-dd"),
        fileIds,
        status: selectedStatus,
      };
      await TicketingSystem.updateTicket(payload, { id });
      toast.show("Ticket Updated Successfully", AlertStatus.SUCCESS);
      setTimeout(() => {
        onClose();
        resetForm();
        setLoading(false);
        onRefresh();
      }, 2000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
      setLoading(false);
    }
  };

  const handleProjectChange = (event) => {
    setSelectedProject(event.target.value);
  };

  const handleClearProject = () => {
    setSelectedProject("");
  };

  const handleModuleChange = (event) => {
    setSelectedModule(event.target.value);
  };

  const handleClearModule = () => {
    setSelectedModule("");
  };

  const handlePriorityChange = (event) => {
    setSelectedPriority(event.target.value);
  };
  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const handleClearPriority = () => {
    setSelectedPriority("");
  };
  const handleClearStatus = () => {
    setSelectedStatus("");
  };

  const handleAssigneeChange = (event) => {
    setSelectedAssignee(event.target.value);
  };

  const handleClearAssignee = () => {
    setSelectedAssignee("");
  };

  const handleAttachmentClick = (attachment) => {
    if (attachment?.signedS3Url !== null) {
      window.open(attachment?.signedS3Url, "_blank");
    }
  };

  // const handleInputChange = useCallback(debounce(onSearchMember), [
  //   selectedAssignee,
  //   options,
  // ]);

  const getTitle = () => {
    if (mode === "view") return "View Ticket";
    if (mode === "edit") return "Update Ticket";
    return "";
  };

  useEffect(() => {
    if (open) {
      onView();
    }
  }, [open]);

  useEffect(() => {
    if (open) {
      fetchRemakrs();
      // fetchTicketId();
    }
  }, [open]);

  useEffect(() => {
    if (onClose) {
      resetForm();
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      customStyle={{
        maxHeight: "98%",
        maxWidth: "100%",
        overflow: "scroll",
        borderRadius: "14px",
        background: "#FFF",
        width: "95%",
      }}
    >
      <Box>
        <Formik initialValues={{ description: "" }} onSubmit={onFormSubmit}>
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "12px 20px",
                  borderBottom: "1px solid #e0e0e0",
                  background: "#fafafa",
                  borderRadius: "10px 10px 0 0",
                }}
              >
                {/* Title */}
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 600, color: "#333" }}
                >
                  {getTitle()}
                </Typography>

                {/* Ticket Info */}
                <Typography
                  variant="body2"
                  sx={{ color: "#666", textAlign: "right" }}
                >
                  <span style={{ fontWeight: 500 }}>Ticket Created By:</span>{" "}
                  {searchData.createdBy ? searchData.createdBy : "-"}{" "}
                  <span style={{ color: "#999" }}>
                    ({searchData.createdByName ? searchData.createdByName : "-"}
                    )
                  </span>
                  {" • "}
                  <span style={{ fontWeight: 500 }}>At:</span>{" "}
                  {searchData.createdAt
                    ? moment(searchData.createdAt).format("DD/MM/YYYY hh:mm A")
                    : "-"}
                </Typography>

                {/* Action */}
                {mode === "view" ? (
                  <Button
                    sx={{
                      ml: 2,
                      borderRadius: "8px",
                      textTransform: "none",
                      px: 2,
                      py: 0.5,
                      fontWeight: 500,
                    }}
                    variant="outlined"
                    onClick={onClose}
                  >
                    Back
                  </Button>
                ) : (
                  <IconButton
                    onClick={onClose}
                    sx={{
                      ml: 2,
                      bgcolor: "#f5f5f5",
                      "&:hover": { bgcolor: "#f40505ff" },
                      borderRadius: "8px",
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                )}
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px 0",
                  flexWrap: "wrap", // mobile view ke liye
                }}
              >
                {/* Left side - Required field note */}
                <Typography style={style.typographyStyle}>
                  Required field are marked with an asterisk{" "}
                  <span style={style.spanStyle}>*</span>
                </Typography>

                {/* Right side - Ticket ID */}
                <Typography
                  variant="subtitle1"
                  sx={{ color: "#043D90", fontWeight: 600 }}
                >
                  Ticket ID: {supportTicketId}
                </Typography>

                {!isViewMode && (
                  <Button
                    style={CommonStyles.buttonStyle}
                    variant="contained"
                    type="submit"
                    label="Update"
                  />
                )}
              </Box>

              <Box style={{ display: "flex" }}>
                {" "}
                <Box style={{ display: "flex", width: "60%" }}>
                  <Box
                    style={{
                      width: "100%",
                    }}
                  >
                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          gap: 4, // dono ke beech ka spacing
                          padding: "10px 0px",
                          flexWrap: "wrap", // mobile me neeche aa jayega
                        }}
                      >
                        {/* Project */}
                        <Box sx={{ flex: 1, minWidth: "200px" }}>
                          {/* <Typography style={style.typographyStyle}>Project</Typography> */}
                          <Box sx={{ pt: 1 }}>
                            <Dropdown
                              value={selectedProject}
                              options={PROJECT_OPTIONS}
                              label="Select"
                              onChange={handleProjectChange}
                              handleClearValue={handleClearProject}
                              disabled
                            />
                          </Box>
                        </Box>

                        {/* Module */}
                        <Box sx={{ flex: 1, minWidth: "200px" }}>
                          {/* <Typography style={style.typographyStyle}>Module</Typography> */}
                          <Box sx={{ pt: 1 }}>
                            <Dropdown
                              value={selectedModule}
                              options={MODULE_OPTIONS}
                              label="Select"
                              onChange={handleModuleChange}
                              handleClearValue={handleClearModule}
                              disabled
                            />
                          </Box>
                        </Box>
                      </Box>

                      {userRole === "helpDesk" && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: 4,
                            padding: "10px 0px",
                            flexWrap: "wrap", // responsive ke liye
                          }}
                        >
                          {/* Priority */}
                          <Box sx={{ flex: 1 }}>
                            {/* <Typography style={style.typographyStyle}>Priority</Typography> */}
                            <Box width="100%" paddingTop="10px">
                              <Dropdown
                                value={selectedPriority}
                                options={PRIORITY_OPTIONS}
                                label="Select"
                                onChange={handlePriorityChange}
                                showCross
                                handleClearValue={handleClearPriority}
                                disabled={isViewMode}
                                sx={{ paddingRight: "0px" }}
                              />
                            </Box>
                          </Box>

                          {/* Status */}
                          <Box sx={{ flex: 1 }}>
                            {/* <Typography style={style.typographyStyle}>Status</Typography> */}
                            <Box width="100%" paddingTop="10px">
                              <Dropdown
                                value={selectedStatus}
                                options={STATUS_OPTIONS}
                                label="Select Status"
                                onChange={handleStatusChange}
                                handleClearValue={handleClearStatus}
                                // disabled={isViewMode}
                                sx={{ paddingRight: "0px" }}
                              />
                            </Box>
                          </Box>
                        </Box>
                      )}

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          gap: 3,
                          padding: "10px 0",
                          flexWrap: "wrap", // mobile responsive
                        }}
                      >
                        {/* Subject */}
                        <Box sx={{ flex: 1 }}>
                          <InputField
                            name="subject"
                            label="Subject"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            disabled
                            fullWidth
                          />
                        </Box>

                        {/* Attachment */}
                        <Box sx={{ flex: 1 }}>
                          {/* <Typography style={style.typographyStyle}>
                            Attachment
                          </Typography> */}
                          <Box
                            {...getRootProps()}
                            sx={{
                              mt: 1,
                              p: 2,
                              border: "1px dashed #ccc",
                              borderRadius: "8px",
                              textAlign: "center",
                              cursor: "pointer",
                              "&:hover": { backgroundColor: "#fafafa" },
                            }}
                          >
                            <input {...getInputProps()} />
                            <FileUploadOutlinedIcon fontSize="small" />
                            <Typography variant="body2" sx={{ mt: 1 }}>
                              Drag & Drop or Click to Browse
                            </Typography>
                          </Box>

                          {/* Gmail-style attachments */}
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 1,
                              mt: 2,
                            }}
                          >
                            {files?.length > 0 &&
                              files.map((attachment, index) => (
                                <Box
                                  key={index}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    px: 1.5,
                                    py: 0.5,
                                    border: "1px solid #ccc",
                                    borderRadius: "16px",
                                    backgroundColor: "#f5f5f5",
                                    fontSize: "14px",
                                    cursor: "pointer",
                                    "&:hover": { backgroundColor: "#eaeaea" },
                                  }}
                                  onClick={() =>
                                    handleAttachmentClick(attachment)
                                  }
                                >
                                  📎 {attachment?.originalFileName}
                                  <ClearIcon
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleRemoveAttachment(
                                        index,
                                        attachment?.id
                                      );
                                    }}
                                    fontSize="small"
                                    sx={{ ml: 1, cursor: "pointer" }}
                                  />
                                </Box>
                              ))}
                          </Box>
                        </Box>
                      </Box>

                      <Box sx={{ padding: "10px 0px" }}>
                        {/* <Typography style={style.typographyStyle}>
                          Description{" "}
                        </Typography> */}
                        <Box width="100%" paddingTop="10px">
                          <TextField
                            id="outlined-multiline-flexible"
                            label="Start writing..."
                            multiline
                            maxRows={6}
                            rows={6}
                            style={{
                              ...style.textFieldStyle,
                              backgroundColor: "rgba(239, 239, 239, 1.5)",
                            }}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            disabled
                            InputProps={{
                              classes: {
                                disabled: "custom-disabled",
                              },
                            }}
                            sx={{
                              "& .MuiOutlinedInput-input.Mui-disabled": {
                                WebkitTextFillColor: "rgba(0, 0, 0, 0.7)",
                                opacity: 1,
                              },
                            }}
                          />
                        </Box>
                      </Box>

                      {userRole === "helpDesk" && (
                        <Box sx={{ padding: "10px 0px" }}>
                          <Typography style={style.typographyStyle}>
                            Assignee
                          </Typography>
                          <Box width="40%" paddingTop="10px">
                            {!isViewMode && (
                              <Box paddingTop="10px">
                                {/* <AutoCompleteDropdown
                                getOptionLabel={(option) => option.displayName}
                                label="Search Member ID"
                                name="searchMember"
                                options={options}
                                value={selectedAssignee}
                                onChange={(selectedValue) => {
                                  if (!selectedValue) {
                                    setSelectedAssignee("");
                                    setOptions([]);
                                  } else {
                                    setSelectedAssignee(selectedValue.value);
                                  }
                                }}
                                onInputChange={handleInputChange}
                                loading={loading}
                                filterSelectedOptions={false}
                                filterOptions={(x) => x}
                                disabled={isViewMode}
                              /> */}
                                <Dropdown
                                  value={selectedAssignee}
                                  options={ASSIGNEE_OPTIONS}
                                  label="Select assignee "
                                  onChange={handleAssigneeChange}
                                  showCross
                                  handleClearValue={handleClearAssignee}
                                />
                              </Box>
                            )}
                            <Box paddingTop="10px">
                              <InputField
                                name="assignee"
                                label="Previous assignee"
                                value={selectedPreAssignee}
                                disabled
                              />
                            </Box>
                          </Box>
                        </Box>
                      )}
                      {/* <Box sx={{ padding: "10px 0px" }}>
                        <Typography style={style.typographyStyle}>
                          Reporter
                        </Typography>
                        <Box width="40%" paddingTop="10px">
                          <Box paddingTop="10px">
                            <InputField
                              name="reporter"
                              label="Reporter"
                              value={selectedReporter}
                              disabled
                            />
                          </Box>
                        </Box>
                      </Box> */}
                      {/* <Box sx={{ padding: "10px 0px" }}>
                        <Typography style={style.typographyStyle}>
                          Due date
                        </Typography>
                        <Box width="40%" paddingTop="10px">
                          <DatePicker
                            defaultValue={selectedAppointmentDate}
                            onDateSelect={onDateSelect}
                            disabled={isViewMode}
                          >
                            <Typography
                              weight={500}
                              variant="small"
                              style={style.dateStyle}
                              disabled={isViewMode}
                            >
                              {selectedAppointmentDate
                                ? format(selectedAppointmentDate, "dd-MM-yyyy")
                                : "NA"}
                              <CalendarMonthOutlinedIcon
                                style={{ paddingLeft: "5px" }}
                              />
                            </Typography>
                          </DatePicker>
                        </Box>
                      </Box> */}
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    width: "2px",
                    backgroundColor: "#e0e0e0",
                    marginX: "10px",
                  }}
                />
                <Box
                  style={{
                    marginLeft: "30px",
                    padding: "15px 10px 0px 0px",
                    width: "40%",
                  }}
                >
                  {/* <Typography style={style.typographyStyle}>
                    Follow up Action
                  </Typography> */}

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      padding: "20px 0",
                    }}
                  >
                    <InputField
                      name="remark"
                      type="text"
                      key="remark"
                      variant="outlined"
                      label="Enter your reply"
                      style={style.inputStyle}
                      value={remark}
                      onChange={(e) => setRemark(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          setRemark((prevRemark) => `${prevRemark}\n`);
                        }
                      }}
                      multiline
                      rows={2}
                      InputProps={{
                        sx: {
                          minHeight: "60px",
                          maxWidth: "100%",
                          height: "auto !important", // force height
                        },
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "auto !important", // override input root height
                          minHeight: "60px",
                        },
                      }}
                      required
                    />
                  </Box>

                  <RemarksList remarks={remarks} />
                </Box>
              </Box>
            </form>
          )}
        </Formik>
        {loading && <Loader />}
      </Box>
    </Modal>
  );
}

export default CreateTicketModal;
